import { TApplicationState } from '../../types/redux';

export const selectsRedirectLink = (state: TApplicationState) => {
  return state.submitForm.redirectUrl;
};
